import { Outlet } from 'react-router-dom';
import { HottrChassis } from '@/components/layout/HottrChassis';

/**
 * The layout route for the authed + onboarded branch of App.tsx.
 *
 * It used to own three navigations at once — a handmade mobile top bar, the kit
 * header in `nav-center` layout, and a handmade mobile bottom tab bar. All of
 * that moved into HottrChassis, which is the shared Screen System chassis and
 * the only place navigation is allowed to live.
 *
 * The file stays because App.tsx mounts it as the layout route and because that
 * mounting is what suppresses the Orb on the pre-login surfaces: `/`,
 * `/onboarding`, `/auth` and `/auth/callback` sit outside this branch, so they
 * never reach the chassis at all.
 */
export function AppShell() {
  return (
    <HottrChassis>
      <Outlet />
    </HottrChassis>
  );
}
